import ReactDOM from 'react-dom';
import React, { useContext, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { store } from 'browser/store';
import useMedia from 'browser/hooks/useMedia';
import usePortal from 'browser/hooks/usePortal';

// Layout Elements
import Nav from 'browser/layout/Nav';
import Breadcrumbs from 'browser/layout/Breadcrumbs';
import Powered from 'browser/layout/Powered';
import FiltersSidebar from 'browser/layout/FiltersSidebar';

const Map = lazy(() => import('browser/layout/Map'));
const Gallery = lazy(() => import('browser/layout/Gallery'));

const LayoutWrapper = styled.div`
  font-family: ${({ theme }) => theme.fonts.mainFont};
  position: relative;
  width: 100%;
  background: #fff;
  height: ${({ height }) => height || 'var(--vh)'};
  ${({ isBuilding }) =>
    isBuilding &&
    css`
      @media (max-width: 991px) {
        height: calc(100vw) !important;
      }
    `}
  ${({ isInvestment }) =>
    isInvestment &&
    css`
      @media (max-width: 991px) {
        height: calc(70vw) !important;
      }
    `}
`;

const LayoutMain = styled.main`
  height: 100%;
`;

const Layout = ({ children, ...props }) => {
  const matchesLG = useMedia('lg');
  const target = usePortal('#browser');
  const {
    state: {
      layoutHeight,
      currentUrl,
      currentBuilding,
      currentFlat,
      currentFloor,
      investment,
    },
  } = useContext(store);

  return (
    <LayoutWrapper
      height={layoutHeight}
      isBuilding={currentBuilding && !currentFloor}
      isInvestment={!currentBuilding}
      {...props}
    >
      {(currentBuilding || matchesLG) && <Nav />}
      {matchesLG && <Breadcrumbs />}
      {!(currentFlat || currentUrl.includes('favourites')) && (
        <>
          {matchesLG ? (
            <FiltersSidebar />
          ) : (
            ReactDOM.createPortal(<FiltersSidebar />, target)
          )}
        </>
      )}
      <LayoutMain id="layout-main">{children}</LayoutMain>
      <Powered />
      {investment.map && !currentFloor && !currentUrl.includes('favourites') && (
        <Suspense fallback={<div />}>
          <Map />
        </Suspense>
      )}
      {investment.gallery &&
        !currentFloor &&
        !currentUrl.includes('favourites') && (
          <Suspense fallback={<div />}>
            <Gallery />
          </Suspense>
        )}
    </LayoutWrapper>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
